import { z, ZodTypeAny } from "zod";
import { InnerContentFrame } from "@shared/ui/InnerContentFrame";
import { Type } from "@shared/ui/Type";
import { Button } from "@shared/ui/Button";

export type Props = {
  stepIndex: number;
  totalSteps: number;
  onSubmit: (data: z.infer<ZodTypeAny>) => Promise<void>;
  label: string;
  disabled: boolean;
  onBack: () => void;
};

export function QuizActions({
  stepIndex = 0,
  totalSteps = 0,
  onSubmit,
  label,
  disabled,
  onBack,
}: Props) {
  return (
    <InnerContentFrame
      className="bg-brand-50 text-brand-800 border-t border-brand-800"
      innerClassName="gap-2 px-4 py-4 md:px-8 md:py-4 md:justify-center md:items-center"
    >
      <Type variant="caption" as="p">
        {stepIndex + 1} of {totalSteps}
      </Type>
      <Button
        onClick={onSubmit}
        type="submit"
        disabled={disabled}
        className="w-full"
        data-testid="quiz-action-submit"
      >
        {label}
      </Button>
      {stepIndex > 0 && onBack && (
        <Button
          onClick={onBack}
          variant="link"
          className="w-full"
          data-testid="quiz-action-back"
        >
          Back
        </Button>
      )}
    </InnerContentFrame>
  );
}

export default QuizActions;
